window.addEventListener("load", function(){
  setTimeout(function(){
    var popup = document.querySelector(".login-onload-popup");
    if (popup) {
      popup.classList.add("show"); // use .show instead of display:block
    }
  }, 1000);
});

document.addEventListener("click", function(e){
  // close button
  if (e.target.closest(".login-onload-popup .close")) {
    e.target.closest(".login-onload-popup").classList.remove("show");
  }
  // clicking outside the box closes popup
  if (e.target.classList.contains("login-onload-popup")) {
    e.target.classList.remove("show");
  }
});